import { ReactNode } from 'react';
import { Element as ParserElement } from 'html-react-parser';
import { SegmentTypes } from '@twiliointernal/e2-commons-shared-libs';

export interface Attributes {
  [key: string]: string;
}

export interface HtmlStringToPasteProps {
  htmlString: string;
}

export enum ParserDomNodeNames {
  Element = 'Element',
}

export interface RenderPasteComponentByClassNameParams {
  attributes: Attributes;
  childElements: NonNullable<ReactNode>;
}

export interface RenderPasteComponentByHtmlTagParams {
  attributes: Attributes;
  childElements: NonNullable<ReactNode>;
  parentElement: ParserElement['parentNode'];
  htmlTag: HTMLElement['tagName'];
  trackEvent: SegmentTypes.SegmentTrackEventMethod;
}
